export function buildGlobalSearchPath(query: string, storageEnabled: boolean) {
  const params = new URLSearchParams({
    source: storageEnabled ? 'all' : 'docs',
    type: 'hybrid',
  })
  const normalizedQuery = query.trim()
  if (normalizedQuery) params.set('q', normalizedQuery)
  return `/search?${params.toString()}`
}
